/*

ALL NETWORK URLS AND ENDPOINTS USED IN THE APP CAN BE STORED HERE FOR EASE OF USE

*/

export const NETWORK_URLS = {
  api_url: 'https://staging-api-checkout.zenhq.io/api/v1/',
  apply_discount: 'carts/cart_token/discounts',
  bookings: 'bookings',
  cart: 'carts',
  create_payment: 'carts/cart_token/payments',
  discount_codes: 'discount_codes/usercode?email=useremail',
  front_configs: 'front_configs',
  get_all_delivery_availabilities: 'delivery_availabilities',
  get_all_stores: 'stores/index_lite', // new stores endpoint,
  // get_all_stores: 'stores', // returns all 
  get_all_zones: 'zones',
  get_carts: 'carts',
  get_cart_by_token: 'carts/cart_token.json',
  get_delivery_available_days: 'delivery_available_days',
  get_delivery_options: 'delivery_options',
  get_payment_options: 'payment_options',
  get_store_credentials: 'stores/store_id/public_credentials',
  get_time_windows: 'delivery_time_windows',
  get_zone_by_lat_lng: 'zones/find_by_location?lat=latcode&lng=lngcode',
  orders: 'orders',
  remove_credit_card: 'carts/cart_token/customer_tokens/credit_card_token',
  schedules_endpoint: 'zip_prefixes/code/zone.json',
  special_items: 'front_configs/special_items',
  store_pickup_option: 'stores/store_id/pickup_option',
  update_billing_address: 'carts/cart_token/billing_addresses',
  update_customer: 'carts/cart_token/customers',
  update_delivery: 'carts/cart_token/deliveries',
  update_shipping_address: 'carts/cart_token/shipping_addresses',
};

// FROM THE URLS WHERE CART TOKEN LATCODE LNGCODE NEED TO BE REPLACED, YOU CAN JUST USE THIS FORMAT BELOW
// NETWORK_URLS.get_cart_by_token.replace('cart_token',token)
